module.exports = __webpack_public_path__ + "static/media/Vindermere - Login.50d1d459.jpg";